import PropTypes from 'prop-types';
import React from 'react';
import { handleLinkClick } from '../handleLinkClick';

export const Link = ({ children, className, href, title, onClick, newTab = false, ...rest }) => (
  <a
    href={href}
    className={className}
    title={title}
    onClick={event => handleLinkClick({ event, href, onClick, newTab })}
    {...rest}
  >
    {children}
  </a>
);

Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  newTab: PropTypes.bool,
};

export default Link;
